module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/38iUrj/tc-custom/scover.jpg",
      "alt": "This image is the cover for the book The Secret Places of the Heart, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Secret Places of the Heart, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("H.G. Wells was so charmed by Margaret Sanger that he based The Secret Places of the Heart on his time with her. The novel -- a thinly-veiled autobiography -- depicts an English gentleman, Sir Richard Hardy, who is attempting to sort out his marital problems while he travels the English countryside in the company of a psychiatrist. The Secret Places of the Heart was, in many ways, a love letter from Wells to Sanger...  (Goodreads)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H. G. Wells\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Herbert George Wells; (21 September 1866 – 13 August 1946) was an English writer. Prolific in many genres, he wrote dozens of novels, short stories, and works of social commentary, history, satire, biography and autobiography. His work also included two books on recreational war games. Wells is now best remembered for his science fiction novels and is often called the \"father of science fiction\", along with Jules Verne and the publisher Hugo Gernsback.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf309572","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0